import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { ApiAuthService } from './auth.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[apiAuthPermissions], [apiAuthNoPermissions], apiAuthCondition',
})
export class ApiAuthPermissionsDirective implements OnInit {
  private _condition: any = true;
  private _noPermissions: string | string[] | string[][] = [];
  private _permissions: string | string[] | string[][] = [];

  constructor(
    private _apiAuth: ApiAuthService,
    private _templateRef: TemplateRef<any>,
    private _viewContainerRef: ViewContainerRef,
  ) {}

  @Input()
  set apiAuthPermissions(permissions: string | string[] | string[][]) {
    this._permissions = permissions;
    this._updateView();
  }

  @Input()
  set apiAuthNoPermissions(noPermissions: string | string[] | string[][]) {
    this._noPermissions = noPermissions;
    this._updateView();
  }

  @Input()
  set apiAuthCondition(condition: any) {
    this._condition = condition;
    this._updateView();
  }

  ngOnInit() {
    this._apiAuth.userSubject.subscribe((user) => {
      this._updateView();
    });
  }

  private _updateView() {
    this._viewContainerRef.clear();
    const hasPermissions =
      !this._permissions ||
      !this._permissions.length ||
      this._apiAuth.hasPermissions(this._permissions);
    const noPermissions =
      !this._noPermissions ||
      !this._noPermissions.length ||
      !this._apiAuth.hasPermissions(this._noPermissions);
    if (this._condition && hasPermissions && noPermissions) {
      this._viewContainerRef.createEmbeddedView(this._templateRef);
    }
  }
}
